import React from 'react';

import metaAdsMarkUrl from './meta-icon.svg';

export const MetaAdsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 287.56 191"
    width="1em"
    height="1em"
    {...props}
  >
    <image href={metaAdsMarkUrl} width="287.56" height="191" preserveAspectRatio="xMidYMid meet" />
  </svg>
);
